export const getFileKind = (file, type = file?.type) => {
  if (type?.startsWith("image")) {
    return "IMAGE";
  }

  if (type === "application/pdf") {
    return "PDF";
  }

  if (type?.startsWith("video")) {
    return "VIDEO";
  }

  return "Document";
};

export const formatFileSize = (size) => {
  switch (true) {
    case size < 1000:
      return size + " byte";
    case size < 1000000:
      return (size / 1000).toFixed(2) + "KB";
    case size >= 1000000:
      return (size / 1000000).toFixed(2) + "MB";
  }
};

export const getImageFileType = (imageFile, type = imageFile?.type) => {
  if (!type) return;
  const parts = type.split("/");

  return parts.length > 1 ? parts[1]?.toUpperCase() : parts[0].toUpperCase();
};
